export default "__VITE_ASSET__C1yJB41y__"